/* FAQ DATA */
const FAQData = {
    title: "Frequently Asked Questions",
    rows: [
        {
            title: "What is Campus recruitment?",
            content: `Campus recruitment refers to the process whereby employers undertake an organised program of attracting and hiring students who are about to graduate from colleges, and universities. (On-campus / Off-campus / Pool-campus) The objective of campus placement is to identify the talented and qualified students before they complete their education.`,
        },
        {
            title: "How can I register myself for a particular company’s placement process?",
            content:
                "Please get in touch with the placement cell or visit UMS. You can also refer to the company's website to get the details.",
        },
        {
            title: "What does it mean that I have been shortlisted by the company?",
            content: `At times, the recruiter may shortlist the candidate from the willingness database sent by the placement cell. `,
        },
        {
            title: "Can a student get more than one offer?",
            content: `Yes, but it has certain conditions attached to it. Please contact the placement cell for more details.`,
        },
        {
            title: "How do I communicate with a particular company?",
            content: `All communication should be routed through the Placement Cell only. Student is not allowed to contact the company's HR directly. Any correspondence from the company to the student must be forwarded to the Placement Cell for records.`,
        },
        {
            title: "Will the results be declared on the same day of the campus placements?",
            content: `Results will be declared on the same day by most of the companies, but a few companies might announce the results later.`,
        },
        {
            title: "If I am awaiting results in one company, am I eligible to attend the drive of other company?",
            content: `You are eligible till the final results are declared by the earlier company. If you are selected, then it is mandatory to take the earlier offer.`,
        },
        {
            title: "Can student with backlog allowed to do internship?",
            content: `Students who want to avail the 6-months internship during their 8th semester must not have more than 3 backlogs.`,
        },
        {
            title: "Can student with internship allowed to sit in campus placement?",
            content: `Students opting 6-month internship will be allowed to appear in campus placements like all other students.`,
        },
        {
            title: "What if my internship complete after result announcement?",
            content: `Internships have to be strictly completed at least one week before the deadline of submitting the grades as mentioned in the academic calendar.`,
        },
        {
            title: "What is Dream and Super Dream package?",
            content: `The Dream Package for CSE/IT, ECE & for all other disciplines students will be 10 LPA, 7 LPA and 6 LPA respectively. Any recruiter offering a compensation package equal to or more than 25LPA will be considered as a Super Dream package.`,
        },
    ],
}

export default FAQData;